<form [formGroup]="sampleForm" (ngSubmit)="onSubmit()">
  <div>
    <input type="text" placeholder="First Name" formControlName="firstName" />
  </div>
  <div>
    <input type="text" placeholder="Last Name" formControlName="lastName" />
  </div>
  <div>
    <input type="number" placeholder="Mobile Number" formControlName="mobile" />
  </div>
  <div>
    <input type="text" placeholder="Address" formControlName="address" />
  </div>

  <button>Submit</button>
</form>
<a [routerLink]="['../dashboard']">Dashboard</a>
